import React, { useEffect } from 'react';
import './App.css';
import AreaCliente from './pages/AreaCliente/AreaCliente';
import { isMobile } from "react-device-detect";
import Checkout from './pages/Checkout/Checkout';
import DeepLink from './pages/AreaCliente/DeeplinkForMobile/DeepLink';


function App() {
  return (
    <div className={`
      h-screen 
      w-full 
      flex 
      ${isMobile && 'bg-green-primary'}
      ${isMobile && 'pt-[1.81rem]'}
    `}>
      {window.location.hostname === "financeiro.kinology.com.br" ?
        <AreaCliente />
        :
        window.location.hostname === "checkout.kinology.com.br" ?
          <Checkout />
          :
          window.location.hostname === "areacliente.kinology.com.br" ?
            <DeepLink />
            :
            <div></div>
      }
    </div>
  );
}

export default App;
